import styled from '@emotion/styled';
import { tokens, Icon } from '@hotjar/hotsauce';

export const SiteListItemStyles = {
  Container: styled.div`
    padding-bottom: ${tokens.spacer.x4};
    border-bottom: 1px solid ${tokens.color.ui_border};
    & + & {
      padding-top: ${tokens.spacer.x4};
    }
  `,
  StyledIcon: styled(Icon)<{ isClickable?: boolean }>`
    margin-left: ${tokens.spacer.x0};
    ${(props) => (props.isClickable ?? false) && 'cursor: pointer;'}
  `,
  SiteHeader: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${tokens.spacer.x2pt5};
  `,
  SiteName: styled.span`
    ${tokens.text('subtitle1')};
    ${tokens.truncateText()};
  `,
  SiteDiscount: styled.span`
    ${tokens.text('caption')};
    color: ${tokens.color.text_light};
    align-self: flex-end;
  `,
  Header: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: ${tokens.spacer.x1} 0;
  `,
  HeaderColumn: styled.span`
    color: ${tokens.color.text_light};
    display: block;
    flex-grow: 0;
    flex-shrink: 0;

    ${tokens.text('caption')};
    ${tokens.truncateText()};

    & + & {
      margin-left: ${tokens.spacer.x2};
    }
  `,
  Row: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${tokens.spacer.x0pt5} 0;
  `,
  Column: styled.div`
    flex-grow: 0;
    flex-shrink: 0;

    ${tokens.truncateText()};

    & + & {
      margin-left: ${tokens.spacer.x2};
    }
  `,
  AllowanceLabel: styled.span`
    margin-right: ${tokens.spacer.x1};

    ${tokens.text('body2')};
  `,
  AllowanceValue: styled.span`
    color: ${tokens.color.text_light};

    ${tokens.text('body2')};
  `,
  AllowanceTooltipIcon: styled(Icon)`
    margin-left: ${tokens.spacer.x0};
  `,
};
